import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';
import { capitalize } from '../../../helpers/str';

import HeaderItemBundle from './HeaderItemBundle';
import HeaderItemHardware from './HeaderItemHardware';
import HeaderItemTariff from './HeaderItemTariff';
import HeaderItemInfo from './HeaderItemInfo';
import HeaderItemVideo from './HeaderItemVideo';

import Slider from '../../basics/slider/Slider';
import SliderSlide from '../../basics/slider/SliderSlide';

class HeaderStage extends PureComponent {

  static getItemComponent(type) {
    switch (type) {
      case 'bundle':
        return HeaderItemBundle;
      case 'hardware':
        return HeaderItemHardware;
      case 'tariff':
        return HeaderItemTariff;
      case 'info':
        return HeaderItemInfo;
      case 'video':
        return HeaderItemVideo;
      default:
        return null;
    }
  }

  static getSliderConfig() {
    const config = {
      CSSWidthAndHeight: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
    };
    return config;
  }

  renderItem(item, index, isFeatured) {
    const { isMediaS } = this.props;
    const Element = HeaderStage.getItemComponent(item.type);
    const clickHandler = item.type === 'video' ? this.props.onShowVideo : null;
    return (
      <div
        className={suitcss({
          componentName: 'HeaderStage',
          descendantName: 'item',
          modifiers: [
            `type${capitalize(item.type)}`,
            isFeatured && 'featured',
          ],
        })}
        key={!isMediaS ? index : null}
        data-tracking="module_position"
        data-module_position={index + 1}
      >
        <Element
          copy={item.headline}
          link={item.link}
          tariff={item.tariff}
          hardware={item.hardware}
          hardwareName={item.hardwareName}
          image={item.backgroundImage}
          videoId={item.youtubeId}
          align={item.textAlign}
          position={item.textPosition}
          featured={isFeatured}
          onClick={clickHandler}
          isNew={item.isNew}
        />
      </div>
    );
  }

  render() {
    const { items, isMediaS } = this.props;
    const totalItems = items.length;
    const featuredTeasers = totalItems === 1 ? items : items.filter(item => item.featured);
    const teasers = totalItems === 1 ? [] : items.filter(item => !item.featured);
    const withTeaserSlider = isMediaS && teasers.length > 1;
    return (
      <div
        className={suitcss({
          componentName: 'HeaderStage',
          modifiers: [
            featuredTeasers.length > 1 && 'featuredColumns',
            totalItems <= 1 && 'standalone',
          ],
        })}
      >
        {!!featuredTeasers.length && (
          <div
            className={suitcss({
              componentName: 'HeaderStage',
              descendantName: 'featured',
            })}
          >
            {featuredTeasers.map((item, key) => this.renderItem(item, key, true))}
          </div>
        )}
        {!withTeaserSlider && !!teasers.length && (
          <div
            className={suitcss({
              componentName: 'HeaderStage',
              descendantName: 'teasers',
            })}
          >
            {teasers.map((item, index) =>
              this.renderItem(item, index + featuredTeasers.length, false),
            )}
          </div>
        )}
        {withTeaserSlider && (
          <Slider
            className={suitcss({ descendantName: 'teasers' }, this)}
            theme="dark"
            config={HeaderStage.getSliderConfig()}
            inverted
            arrows
          >
            {teasers.map((item, index) => (
              <SliderSlide key={index + featuredTeasers.length}>
                {this.renderItem(item, index + featuredTeasers.length, false)}
              </SliderSlide>
            ))}
          </Slider>
        )}
      </div>
    );
  }
}

HeaderStage.propTypes = {
  items: PropTypes.array.isRequired,
  onShowVideo: PropTypes.func,
  isMediaS: PropTypes.bool,
};

HeaderStage.defaultProps = {};

export default HeaderStage;
